function openLinkedAnswer() {
  const answer = document.getElementById(window.location.hash.slice(1));
  if (answer && answer.matches(".faq details")) {
    answer.open = true;
    answer.scrollIntoView();
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", openLinkedAnswer, { once: true });
} else {
  openLinkedAnswer();
}
window.addEventListener("hashchange", openLinkedAnswer);
